import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class DeviceIdService {

  constructor() { }

  getDeviceID(): Promise<string>
  {
    return Promise.resolve(uuid());
  }
}


